import React, { useContext, useEffect } from "react";
import { ClassTypeContext } from "../../context/ClassTypesContext";
import { classTypesBackgrounds } from "../../utils/classTypes";
import useBranch from "../../hooks/useBranch";

const ClassTypesCaption = ({ currentClasses }) => {
  const { getClassTypes, class_types } = useContext(ClassTypeContext);
  const { branch_id } = useBranch();

  useEffect(() => {
    getClassTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderHomeClassTypes = () => {
    if (Array.isArray(class_types) && class_types.length > 0) {
      const activeTypeIds = new Set();
      if (Array.isArray(currentClasses)) {
        currentClasses.forEach((day) => {
          day?.details?.forEach((c) => {
            if (c?.class_type?.class_type_id != null) {
              activeTypeIds.add(c.class_type.class_type_id);
            }
          });
        });
      }

      const homeClassTypes = class_types
        .filter((type) => type?.show_home)
        .filter((type) => type?.branch_id === branch_id)
        .filter((type) => activeTypeIds.has(type?.class_type_id))
        .sort((a, b) => a.order - b.order);

      return homeClassTypes.map((type) => {
        return (
          <div
            key={type.class_type_id}
            className="d-flex flex-column w-max-content align-items-center"
          >
            <span className="w-max-content">{type?.name}</span>
            <span
              className="badge rounded-pill mb-2"
              style={{
                backgroundColor: classTypesBackgrounds[type?.short_code],
                width: "70px",
                ...(type?.short_code === "G&T"
                  ? { color: "var(--dark)" }
                  : {}),
              }}
            >
              {type?.short_code}
            </span>
          </div>
        );
      });
    }
  };

  return <div className="row">{renderHomeClassTypes()}</div>;
};

export default ClassTypesCaption;
